module.exports = __webpack_public_path__ + "img/H14-3.png";